module.exports = __webpack_public_path__ + "static/media/desktopScreen.228a52f7.png";